<!-- Второй ряд -->
<div class="row row-cols-1 row-cols-md-3 row-gap-2">

    <div class="col" *ngIf="isAdmin">
        <label for="state" class="input-label">Carrier<span class="required">*</span></label>
        <div class="dropdown">
            <select class="form-select input-label" [(ngModel)]="carrierSelected" (change)="checkFieldsCarrier()"
                    [class.is-invalid]="!carrierSelected" [disabled]="isEditing">
                <option value="">Select Value</option>
                <option *ngFor="let option of carriers" [value]="option.aCarrierId">
                    {{ option.aCarrierName }}
                </option>
            </select>
            <div class="invalid-feedback">
                Carrier is required
            </div>
        </div>
    </div>
    <div class="col">
        <label for="iccid">ICCID<span class="required">*</span></label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="iccid" appOnlyNumbers
               [disabled]="isEditing" (input)="checkFieldIccid()" />
    </div>
    <div class="col">
        <label for="imei" class="">IMEI<span class="required" *ngIf="shouldShowZipCodeAsterisk()">*</span></label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="imei"
               [class.is-invalid]="getCarrierNameById(carrierSelected) === carrierConstants.vzw && !imei && isStatusActive" />
        <div class="invalid-feedback">
            IMEI is required for Verizon.
        </div>
    </div>
    <div class="col">
        <label for="mdn" class="">MDN</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="mdn" [disabled]="!isAdmin" />
    </div>



    <div class="col">
        <label for="modemType">Modem Type</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="modemType" [disabled]="!isAdmin && !isPartner" />
    </div>
    <div class="col">
        <label for="serialNumber" class="">Serial Number</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="serialNumber" [disabled]="!isAdmin && !isPartner" />
    </div>

    <div class="col-4">
        <label for="ip" class="">Static IP</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="ip" [disabled]="!isAdmin" />
    </div>

    <div class="col">
        <label for="deviceName">Username</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="deviceName" />
    </div>
    <div class="col-4">
        <label for="deviceName2" class="">Username 2</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="deviceName2" />
    </div>
    <div class="col-4">
        <label for="custom1" class="">Custom Field 1</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="custom1" />
    </div>
    <div class="col-4">
        <label for="custom2" class="">Custom Field 2</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="custom2" />
    </div>
    @if(isAdmin) {
    <div class="col">
        <label for="mtn">MDN Zip Code - {{zipCode}}<span *ngIf="shouldShowZipCodeAsterisk()" class="required">*</span></label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="zipCode"
               [disabled]="getCarrierNameById(carrierSelected) !== carrierConstants.vzw"
               [class.is-invalid]="getCarrierNameById(carrierSelected) === carrierConstants.vzw && !zipCode && isStatusActive" />
        <div class="invalid-feedback">
            MDN Zip Code is required for Verizon.
        </div>
    </div>
    <div class="col">
        <label for="state" class="input-label">Rate Plan<span class="required">*</span></label>
        <div class="dropdown">
            <select class="form-select input-label" [(ngModel)]="selectedRatePlanId" (change)="checkFields()"
                    [class.is-invalid]="!selectedRatePlanId && isStatusActive">
                <option value="">Select Value</option>
                <option *ngFor="let option of filteredRatePlans" [ngValue]="option.ratePlanId">
                    {{ option.ratePlanName }}
                </option>
            </select>
            <div class="invalid-feedback">
                Rate Plan is required.
            </div>
        </div>
    </div>
    }

    <div class="col">
        <label for="state" class="input-label">Assigned to</label>
        <div class="dropdown">
            <select class="form-select input-label" [(ngModel)]="assignedSelected" (change)="checkFields()" [disabled]="!isAdmin">
                <option value="">Select Value</option>
                <option *ngFor="let option of listAssignedTo" [value]="option.aValue">
                    {{ option.aDescription }}
                </option>
            </select>
        </div>
    </div>


    <div class="col">
        <label for="costcenter" class="">Cost Code</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="costCenter" [disabled]="!isAdmin"/>
    </div>

    <div class="col">
        <label for="firstname">First Name</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="firstName" [disabled]="!isAdmin && !isPartner" />
    </div>
    <div class="col">
        <label for="lastname" class="">Last Name</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="lastName" [disabled]="!isAdmin && !isPartner" />
    </div>





    <div class="col">
        <label for="linkworxActivationDate">Linkworx - Activation Date</label>
        <input type="date" class="form-control input-label" (input)="checkFields()" id="linkworxActivationDate"
               [(ngModel)]="linkworxActivationDate" name="linkworxActivationDate" [disabled]="!isAdmin" />
    </div>

    <div class="col">
        <label for="lastname" class="">Originated From</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="originatedFrom" [disabled]="!isAdmin" />
    </div>

    <div class="col" *ngIf="isEditing && isAdmin">
        <label for="deactivationDate">Deactivation Date</label>
        <input type="date" class="form-control input-label" id="deactivationDate"
               [ngModel]="deactivationDate" name="deactivationDate" [disabled]="true" />
    </div>

    <div class="col" *ngIf="isEditing && isAdmin">
        <label for="suspensionDate">Suspension Date</label>
        <input type="date" class="form-control input-label" id="suspensionDate"
               [ngModel]="suspensionDate" name="suspensionDate" [disabled]="true" />
    </div>


    <div class="col" *ngIf="isAdmin && (isEditing || carrierSelected === '3')">
        <label for="state" class="input-label">Status<span class="required">*</span></label>
        <div class="dropdown">
            <select class="form-select input-label" [(ngModel)]="selectedStatus" (change)="checkFields()"
                    [class.is-invalid]="!selectedStatus && isStatusActive">
                <option value="">Select Value</option>
                <option *ngFor="let option of listStatusSim" [value]="toNumber(option.aValue)">
                    {{ option.aNameStatus }}
                </option>
            </select>
            <div class="invalid-feedback">
                Status is required.
            </div>
        </div>
    </div>

    <div class="col" *ngIf="!isAdmin && userPlans.length > 0">
        <label for="state" class="input-label">Assign Plan<span class="required">*</span></label>
        <div class="dropdown">
            <select class="form-select input-label" [(ngModel)]="selectedUserPlanId" (change)="checkFields()">
                <option value="">Select a Plan</option>
                <option *ngFor="let option of userPlans" [value]="option.userPlanId">
                    {{ option.planName }}
                </option>
            </select>
            <div class="invalid-feedback">
                Destination plan is required.
            </div>
        </div>
    </div>

    <div class="col-4 d-flex align-items-center" *ngIf="!isAdmin || userPlans.length > 0">
        <div class="form-check form-check-edit">
            <input class="checkbox me-2" style="margin-left: -1.5rem" type="checkbox" id="flexCheckDefault"
                   [(ngModel)]="isPrimaryDevice" />
            <label class="form-check-label" for="flexCheckDefault">
                Primary Device
            </label>
        </div>
    </div>


</div>
<!-- Cuarta fila -->
<div class="row mt-2">
    <div class="col text-end">
        <button *ngIf="isEditing" class="btn btn-primary w-100 w-md-auto" [disabled]="!fieldsCompleted || disableSave"
                (click)="openConfirmationModalUpdate()">
            Update Device
        </button>
        <button *ngIf="!isEditing" class="btn btn-primary w-100 w-md-auto" [disabled]="!fieldsCompleted || disableSave"
                (click)="openConfirmationModalUpdate()">
            Create Device
        </button>
    </div>
</div>


<!-- Modal Confirmation Update -->
<div class="modal fade" id="deviceConfirmationUpdateAlert" tabindex="-1" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="isEditing" class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                    Update Device
                </h5>
                <h5 *ngIf="!isEditing" class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                    Create Device
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="updateSim(false)"></button>
            </div>
            <div *ngIf="isEditing" class="modal-body">Are you sure you want to update this SIM?</div>
            <div *ngIf="!isEditing" class="modal-body">Are you sure you want to create this SIM?</div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateSim(false)">
                    Close
                </button>
                <button *ngIf="isEditing" type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        (click)="updateSim(true)">
                    Yes, Update
                </button>
                <button *ngIf="!isEditing" type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        (click)="updateSim(true)">
                    Yes, Create
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Error Message -->
<div class="modal fade" id="errorMesaggeModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                    Error Message
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="clearMessage()"></button>
            </div>
            <div class="modal-body">
                {{
                errorMessage
                }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="clearMessage()">
                    Accept
                </button>
            </div>
        </div>
    </div>
</div>
